// generated by svgr from images/facebook.svg

import { memo, type VFC } from 'react'

const FacebookIcon: VFC<any> = (props) => {
  return (
    <svg viewBox='0 0 28 30' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.81 27.95c0 .9-.69 1.63-1.53 1.63H1.53C.7 29.58 0 28.85 0 27.95V1.63C0 .73.69 0 1.53 0h24.75c.84 0 1.53.73 1.53 1.63v26.32zm-8.62-9.82v11.45h-4.33V18.13h-3.63v-4.47h3.63v-3.3c0-3.81 2.19-5.9 5.4-5.9 1.53 0 2.85.13 3.23.18v4h-2.22c-1.74 0-2.08.88-2.08 2.17v2.85h4.16l-.55 4.46h-3.6z'
      />
    </svg>
  )
}

export default memo(FacebookIcon)
